import type { Store } from "redux";
import GlobalHeader from "storefront/components/Page/SiteHeader";
import createApp from "../../containers/home";

const render = (store: Store) => {
  const target = window.document.getElementById("globalHeader");
  if (target) {
    return createApp(target, GlobalHeader, store);
  }
};

export default render;
